import { ReactElement } from 'react';
import { useTranslate } from '@client/i18n/hooks';
import {
  ADD_TO_WISHLIST_STYLE_TYPE,
  AddToWishlistAction,
} from '@client/product/components/ProductActions/AddToWishlistAction';
import { ActionLink } from '@lib/components/ActionLink';
import { ICON_NAME, ICON_SIZE } from '@lib/components/Icon';
import classNames from 'classnames';
import { Props } from './';
import './Buttons.scss';

export const Buttons = ({
  sku,
  isVisible,
  onRemove,
  className,
}: Props): ReactElement => {
  const t = useTranslate();

  return (
    <div className={classNames(className, 'CartProductButtons-Box')}>

      <AddToWishlistAction
        skus={[sku]}
        styleType={ADD_TO_WISHLIST_STYLE_TYPE.link}
        className={classNames(
          'CartProductButton',
          { 'CartProductButton--Visible': isVisible },
        )}
      />

      <ActionLink
        iconName={ICON_NAME.remove}
        iconSize={ICON_SIZE.small}
        onClick={onRemove}
        className={classNames(
          'CartProductButton',
          { 'CartProductButton--Visible': isVisible },
        )}
      >
        {t('Remove')}
      </ActionLink>
    </div>
  );
};
